import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOGIN_FID_CARD } from '../../../constants/routes';
import LoginPopup from '../../../components/connexion/LoginPopup';
import { auth } from '../../../firebase/firebaseConfig';
import { useDispatch, useSelector } from 'react-redux';
import GetUserInfo from '../GetUserInfo';
import { authenticate } from '../../../actions/authenticateActions';
import { saveUser, saveUserWithFid } from '../../../actions/userActions';
import { notifyWarning } from '../../../utils/Notify';
import useAxios
 from '../../../axios/useAxios';
import PageLoader from '../../../components/loader/PageLoader';
import PrimaryButton from '../../../components/button/PrimaryButton';
import BackButton from '../../../components/button/BackButton';

export const GetRedirectInfo = async (
  auth,
  user,
  setLoadingConnexion,
  dispatch,
  axiosInstance,
  cartItems,
  navigate,
  fidCardNum,
) => {
  try {
    const data = await GetUserInfo(auth, user);
    authenticate(
      axiosInstance,
      data.newResult.profile.email,
      data.result.user.accessToken,
    )
      .then(() => {
        // dispatch(saveUserWithFid(data.newResult.profile, axiosInstance, cartItems, fidCardNum, navigate));
        if (fidCardNum) {
          dispatch(
            saveUserWithFid(
              data.newResult.profile,
              axiosInstance,
              cartItems,
              fidCardNum,
              navigate,
            ),
          );
        } else {
          dispatch(
            saveUser(
              data.newResult.profile,
              axiosInstance,
              cartItems,
              navigate,
            ),
          );
        }
      })
      .catch((error) => {
        notifyWarning(
          'Oups',
          'Une erreur est survenue lors de ta connexion.',
          'Ok',
        );
        console.error('Authenticate', error);
      })
      .finally(() => setLoadingConnexion(false));
  } catch (error) {
    console.error(
      "Une erreur s'est produite lors de l'authentification avec Google:",
      error,
    );
  }
};
const FidLoginScreen = () => {
  const [isRegistration, setIsRegistration] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axiosInstance = useAxios();
  const { cartItems } = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const [hasFidelityCard, setHasFidelityCard] = useState(false);
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [showLogin, setShowLogin] = useState(false);
  const [, setLoadingConnexion] = useState(false);

  useEffect(() => {
    if (state?.fidCardNum) {
      localStorage.setItem('fidCardNum', state.fidCardNum);
    } else {
      console.warn('Page might not have been initialized with fidId');
    }
    auth.onAuthStateChanged(async (firebaseUser) => {
      if (user?._id && user.email) {
        setLoadingConnexion(false);
      } else if (firebaseUser?.email) {
        setLoadingConnexion(true);
        await GetRedirectInfo(
          auth,
          user,
          setLoadingConnexion,
          dispatch,
          axiosInstance,
          cartItems,
          navigate,
          localStorage.getItem('fidCardNum'),
        );
      } else {
        setLoadingConnexion(false);
      }
    });
  }, []);

  const switchToLoginPopin = () => {
    setIsRegistration(false);
  };

  const handleLoginPopin = (fidCardExist) => {
    setHasFidelityCard(fidCardExist);
    setIsRegistration(false);
    setShowLogin(true);
  };

  const closeLoginPopin = () => {
    setShowLogin(false);
  };
  const handleSignUpPopin = () => {
    setHasFidelityCard(false);
    setIsRegistration(true);
    setShowLogin(true);
  };

  const getContextQuestion = state?.userMaskedEmail
    ? `Cette carte est déjà associée au compte PikkoPay ${state.userMaskedEmail}`
    : "Cette carte n'est pas encore associée à un compte PikkoPay ?";

  if (!state?.fidCardNum) {
    return <PageLoader />;
  }

  return (
    <div className="fidelity-login">
      <BackButton
        onClick={() => navigate(LOGIN_FID_CARD)}
        isLogoVisible={true}
      />
      {!!state?.fidCardNum && (
        <div className="fidelity-card-id">{`Id : ${state.fidCardNum}`}</div>
      )}
      <div className="fidelity-context">{getContextQuestion}</div>
      {state?.userMaskedEmail ? (
        <PrimaryButton
          onClick={() => handleLoginPopin(true)}
          label="Me connecter à un compte existant"
        />
      ) : (
        <div className="relative top-10 flex flex-col gap-10">
          <PrimaryButton
            onClick={handleSignUpPopin}
            label="Créer un compte PikkoPay"
          />
          <PrimaryButton
            onClick={() => handleLoginPopin(false)}
            label="Associer à un compte existant"
          />
        </div>
      )}
      {showLogin && (
        <LoginPopup
          onClose={closeLoginPopin}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          user={user}
          auth={auth}
          fidCardId={!!state?.userMaskedEmail ? undefined : state?.fidCardNum}
          connexion={switchToLoginPopin}
          isRegistration={isRegistration}
          setIsRegistration={setIsRegistration}
          hasFidelityCard={hasFidelityCard}
        />
      )}
    </div>
  );
};

export default FidLoginScreen;
